export enum PipelineMeasureEnum {
  consideration = 'consideration',
  agentGross = 'agent_gross',
  agentGrossProb = 'agent_gross_prob',
  totalSf = 'total_sf',
  totalAc = 'total_ac',
}
